import { sumBy } from "lodash";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { IProductionGeneralInfoItem, NO_VALUE_DISPLAY } from "@ryde/shared";

import {
  GeneralInfoBlock,
  GeneralInfoNumberBlock,
  GeneralInfoTextBlock,
  GeneralInfoTitleBlock,
} from "../components";

interface IProductionGeneralInfoBlockProps {
  title: string;
  items: IProductionGeneralInfoItem[];
}

export const ProductionGeneralInfoBlock: FC<
  IProductionGeneralInfoBlockProps
> = ({ title, items }) => {
  const { t } = useTranslation();

  return (
    <GeneralInfoBlock>
      <GeneralInfoTitleBlock>
        {t(`booking.generalInfo.${title}`)} (
        {title === "bookings" ? sumBy(items, "count") : items.length})
      </GeneralInfoTitleBlock>
      <div>
        {items.map((item, index) => (
          <span key={item.translationKey || item.name || index}>
            <GeneralInfoTextBlock>
              {item.translationKey
                ? t(item.translationKey)
                : item.name || NO_VALUE_DISPLAY}
            </GeneralInfoTextBlock>{" "}
            <GeneralInfoNumberBlock>({item.count})</GeneralInfoNumberBlock>
            {index !== items.length - 1 ? ", " : ""}
          </span>
        ))}
      </div>
    </GeneralInfoBlock>
  );
};
